document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('a[href^="#"]').forEach(function(link) {
    link.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) { e.preventDefault(); target.scrollIntoView({behavior:'smooth'}); }
    });
  });
});

document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[data-pack-variant-select]').forEach(function (select) {
    var panel = select.closest('.product-panel');
    if (!panel) return;

    var price = panel.querySelector('[data-product-price-value]');
    var summary = panel.querySelector('[data-pack-selection-summary]');
    var defaultOption = Array.prototype.find.call(select.options, function (option) {
      return (option.getAttribute('data-title') || '').toLowerCase().indexOf(' seul') !== -1;
    });
    var requestedVariant = null;

    try {
      requestedVariant = new URL(window.location.href).searchParams.get('variant');
    } catch (error) {
      requestedVariant = null;
    }

    if (defaultOption) {
      defaultOption.setAttribute('data-default-pack-option', '');
      if (select.firstElementChild !== defaultOption) select.insertBefore(defaultOption, select.firstElementChild);
      if (!requestedVariant) select.value = defaultOption.value;
    }
    if (requestedVariant) select.value = requestedVariant;

    function updatePackSelection() {
      var option = select.options[select.selectedIndex];
      if (!option) return;

      if (price) price.textContent = option.getAttribute('data-price') || '';
      if (summary) summary.textContent = option.getAttribute('data-title') || option.textContent;

      try {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url.toString());
      } catch (error) {
        // The selector remains functional when URL rewriting is unavailable.
      }
    }

    select.addEventListener('change', updatePackSelection);
    updatePackSelection();
  });
});
